import { render, staticRenderFns } from "./DefaultParameters.vue?vue&type=template&id=b6438868&scoped=true&"
import script from "./DefaultParameters.vue?vue&type=script&lang=js&"
export * from "./DefaultParameters.vue?vue&type=script&lang=js&"
import style0 from "./DefaultParameters.vue?vue&type=style&index=0&id=b6438868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6438868",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard,VCardText})
